import { render, staticRenderFns } from "./ResultStudentsList.vue?vue&type=template&id=7b4ed6d4&scoped=true&lang=pug&"
import script from "./ResultStudentsList.vue?vue&type=script&lang=js&"
export * from "./ResultStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./ResultStudentsList.vue?vue&type=style&index=0&id=7b4ed6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ed6d4",
  null
  
)

export default component.exports